/**
 * La grille de créneaux vit dans `src/data/utility/constraintsGrid.js`, lisible
 * par les écrans legacy ET par les ports de l'espace parent (qui ne lisent pas
 * `src/common`). Ce ré-export garde le chemin de ses lecteurs legacy.
 */
export * from "@data/utility/constraintsGrid"
